type PropTypes = {
  className?: string
}

const ProjectIcon = ({ className }: PropTypes) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 14"
      className={className}
    >
      <path
        fill="currentColor"
        d="m5.283 1.375 1.924 1.918.326.332h7.217v9H1.25V1.375h4.033Zm0-1.125H1.25A1.125 1.125 0 0 0 .125 1.375v11.25A1.125 1.125 0 0 0 1.25 13.75h13.5a1.125 1.125 0 0 0 1.125-1.125v-9A1.125 1.125 0 0 0 14.75 2.5H8L6.082.582A1.125 1.125 0 0 0 5.283.25Z"
      />
    </svg>
  )
}

export default ProjectIcon
